<template>
  <div>
    <slot name="password">
      <div class="form-group">
        <label
          class="form-control-label hidden"
          for="password"
        >New Password</label>
        <div class="input-icon">
          <i class="faw fas fa-lock" />
        </div>
        <input
          v-model="localNewPassword"
          v-validate="'required'"
          class="form-control"
          :class="{ 'is-invalid': !isValidPassword && localNewPassword }"
          type="password"
          name="password"
          placeholder="New Password"
          @change="$emit('update:newPassword', localNewPassword)"
        >
        <div
          v-if="!isValidPassword && localNewPassword"
          class="invalid-feedback d-block"
        >
          <span>{{ invalidPasswordMessage }}</span>
        </div>
      </div>
      <div class="form-group">
        <label
          class="form-control-label hidden"
          for="password"
        >Confirm Password</label>
        <div class="input-icon">
          <i class="faw fas fa-lock" />
        </div>
        <input
          v-model="localConfirmPassword"
          v-validate="'required'"
          class="form-control"
          :class="{ 'is-invalid': !isValidPassword && localConfirmPassword }"
          type="password"
          name="password"
          placeholder="Confirm Password"
          @change="$emit('update:confirmPassword', localConfirmPassword)"
        >
        <div
          v-if="localConfirmPassword"
          class="invalid-feedback d-block"
        >
          <span>{{ passwordNotMatchMessage }}</span>
        </div>
      </div>
      <div
        v-if="localNewPassword"
        class="col-12 row pt-2"
      >
        <div class="col-sm-5 col-md-4">
          Password Strength
        </div>
        <div class="col-sm-7 col-md-8">
          <PasswordStrength
            v-model="localNewPassword"
            :strength-meter-only="true"
          />
        </div>
      </div>
    </slot>
  </div>
</template>

<script>
import PasswordStrength from 'vue-password-strength-meter'

export default {
  name: 'Password',
  components: {
    PasswordStrength
  },
  props: {
    newPassword: {
      type: String,
      default: '',
      requried: true
    },
    confirmPassword: {
      type: String,
      default: '',
      required: true
    }
  },
  data () {
    return {
      localNewPassword: this.newPassword,
      localConfirmPassword: this.confirmPassword
    }
  },
  computed: {
    invalidPasswordMessage () {
      if (!this.isPasswordLengthSatisfied) {
        return 'Password needs to be at least 8 characters long.'
      }
      if (!this.doesPasswordContainsSpecialCharacter) {
        return 'Password needs to have at least one special character.'
      }
      if (!this.doesPasswordContainsAtleastOneNumber) {
        return 'Password needs to have at least one number character.'
      }
      return ''
    },
    passwordNotMatchMessage () {
      return this.passwordAndConfirmPasswordMatch
        ? ''
        : 'Password and confirm password does not match.'
    },
    passwordAndConfirmPasswordMatch () {
      return this.localNewPassword === this.localConfirmPassword
    },
    isValidPassword () {
      const isValid =
        this.passwordAndConfirmPasswordMatch &&
        this.isPasswordLengthSatisfied &&
        this.doesPasswordContainsSpecialCharacter &&
        this.doesPasswordContainsAtleastOneNumber
      const validationMessage = this.invalidPasswordMessage
        ? this.invalidPasswordMessage
        : this.passwordNotMatchMessage
      const source = this.invalidPasswordMessage
        ? 'newPassword'
        : 'confirmPassword'
      this.$emit('passwordValidation', { isValid, validationMessage, source })
      return isValid
    },
    isPasswordLengthSatisfied () {
      return this.localNewPassword && this.localNewPassword.length >= 8
    },
    doesPasswordContainsSpecialCharacter () {
      // eslint-disable-next-line no-useless-escape
      return /[!@#\$%\^\&*\)\(+=._-]/.test(this.localNewPassword)
    },
    doesPasswordContainsAtleastOneNumber () {
      // eslint-disable-next-line no-useless-escape
      return /\d/.test(this.localNewPassword)
    }
  },
  watch: {
    newPassword () {
      this.updateLocalValues()
    },
    confirmPassword () {
      this.updateLocalValues()
    }
  },
  methods: {
    updateLocalValues () {
      this.localNewPassword = this.newPassword
      this.localConfirmPassword = this.confirmPassword
    }
  }
}
</script>

<style lang="scss" scoped>
  @media (min-width: 768px) {
    .input-icon ~ input {
      padding-left: 50px;
    }
  }

  input {
    background-repeat: no-repeat;
    background-attachment: scroll;
    background-size: 16px 18px;
    background-position: 98% 50%;
    cursor: auto;
  }

  .input-icon {
    position: absolute;
    width: 30px;
    height: 46px;
    z-index: 100;
  }

  .input-icon .faw {
    color: #778598;
    padding: 0 7px;
    margin: 1px 1px 1px 5px;
    line-height: 40px;
    font-size: 1rem;
  }

  .input-icon ~ input {
    padding-left: 40px;
  }
</style>
